<template>
    <div class="footerBox">
        <div class="container">
            <div class="footerLink">
                <div class="footerLink_item linkHover" @click="go_home('/')">网站首页</div>
                <div class="footerLink_item linkHover" @click="go_route('/about_us')">关于我们</div>
                <div class="footerLink_item linkHover" @click="go_route('/contact')">联系我们</div>
                <div class="footerLink_item linkHover" @click="go_route('/support')">客服中心</div>
                <div class="footerLink_item linkHover" @click="go_route('/help_center')">帮助中心</div>
                <div class="footerLink_item linkHover" @click="go_route('/faq')">常见问题</div>
                <div class="footerLink_item linkHover" @click="go_route('/terms_of_service')">服务协议</div>
                <div class="footerLink_item linkHover" @click="go_route('/privacy_olicy')">隐私政策</div>
                <div class="footerLink_item linkHover" @click="go_route('/Legal_notice')">法律声明</div>

            </div>
            <div class="flex justify-between items-center">
                <el-image :src="require('@/assets/nav-log-light.png')" style="width:188px;height: 50px;"></el-image>
                <div class="colorFFF font13 text-center" style="line-height: 25px;">
                    CopyRight © 2026 By zhuzaobao.com All Rights Reserved.<br>
                    版权所有 铸联网络 保留所有权利 <span class="marginR10 marginL10">铸造宝信息服务平台</span><span>版本:V1.0.0</span><br>
                    <div class="flex items-center">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13060602001870" rel="noreferrer" target="_blank" style="text-decoration: none;" class="colorFFF marginR20">
                            <div class="flex items-center">
                                <el-image :src="require('@/assets/jgwab.png')" style="width: 16px;height: 16px;"></el-image>
                                <span class="marginL10">冀公网安备13060602001870号</span>
                            </div>
                        </a>
                        <a href="http://beian.miit.gov.cn" target="_blank" class="colorFFF" style="text-decoration: none;">冀ICP备14016434号-3</a><br>
                        
                    </div>
                    <div><a href="https://dxzhgl.miit.gov.cn/" target="_blank" class="colorFFF" style="text-decoration: none;">增值电信业务经营许可证：冀B2-20260363</a></div>        
                    
                </div>
                <el-image :src="require('@/assets/server_phone.png')" style="width:285px;height: 28px;"></el-image>
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        name:'',
        props:[''],
        data () {
            return {
                searchForm:{},
            }
        },
        components: {},
        computed: {
            
        },
        beforeMount() {},
        mounted() {},
        methods: {
            go_home(path){
                this.$router.push({path:path})
            },
            go_route(path){
                const routeData = this.$router.resolve({
                    path: path,
                });
                window.open(routeData.href, '_blank');
            },
        },
    }

</script>

<style lang='scss' scoped>
.footerBox{
    width: 100%;
    min-width: 1200px;
    padding: 30px 0;
    background-color: #000000;
    
}
.footerInputBtn{
    width: 85px;
    height: 55px;
    border-radius: 0 5px 5px 0;
    line-height: 55px;
    color: #fff;
    text-align: center;
    cursor: pointer;
}
.footerInput{
    ::v-deep .el-input__inner{
        border: none;
        height: 55px;
        font-size: 16px;
        border-radius: 5px 0 0 5px;
    }
}
.footerIcon{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #fff;
    color: #999;
    text-align: center;
    line-height: 40px;
    font-size: 22px;
    cursor: pointer;
    margin-right: 10px;
    &:hover{
        color: #fff;
        background-color: red;;
    }
}
.footerLink{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 14px;
    .footerLink_item{
        margin-bottom: 20px;
        cursor: pointer;
        margin-right: 20px
    }
}
</style>